<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="showBack">
      <ion-button (click)="goToIndex()" aria-label="Back to help index">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="help-modal-content">
  <div class="help-search">
    <ion-searchbar placeholder="Search help" [(ngModel)]="searchQuery" (ionInput)="onSearchChange()"></ion-searchbar>
    <div *ngIf="searching">Searching...</div>
    <div *ngIf="searchResults?.length">
      <ul>
        <li *ngFor="let r of searchResults"><button type="button" class="link-like" (click)="selectSearchResult(r)">{{ r.title }}</button></li>
      </ul>
    </div>
  </div>

  <!-- Category cards view (landing) -->
  <div *ngIf="!selectedCategory && categories && categories.length && !content && !loadingTopic" class="category-cards">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-sm="6" size-md="4" *ngFor="let c of categories">
          <ion-card class="category-card" button (click)="selectCategory(c.category)">
            <ion-card-header class="category-card-header">
              <ion-icon [name]="getCategoryIcon(c.category)" class="category-icon"></ion-icon>
              <ion-card-title>{{ formatCategoryName(c.category) }}</ion-card-title>
            </ion-card-header>
            <ion-card-content class="category-card-content">
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <!-- Selected category: show documents list -->
  <div *ngIf="selectedCategory && selectedCategoryDocs && !content && !loadingTopic" class="category-list">
    <h3>{{ formatCategoryName(selectedCategory) }}</h3>
    <ul>
      <li *ngFor="let d of selectedCategoryDocs"><button type="button" class="link-like" (click)="loadTopicById(d.id)">{{ d.title }}</button></li>
    </ul>
  </div>

  <!-- Topic content (fallback to injected HTML) -->
  <div #contentContainer class="help-topic-content" *ngIf="content" [innerHTML]="content"></div>
</ion-content>
